import { Grid, Typography, Box } from "@mui/material"
import type { orderItem as OrderItemType } from './VerificationType'
import { Fragment } from "react"

type routing = {
  routing_number: string,
  answered_after?: number,
  routing_order_item_id?: number
}

type configType = {
  inbound_number: string,
  routing_type: string,
  routing_business_hours: routing[],
  routing_after_hours?: routing[],
  business_hour_from?: string,
  business_hour_to?: string,
  business_days?: {
    monday: number,
    tuesday: number,
    wednesday: number,
    thursday: number,
    friday: number,
    saturday: number,
    sunday: number
  },
}

const labelStyle = { color: '#7A97B0', fontSize: '14px!important', fontWeight: 400 }
const valueStyle = { fontWeight: 500, fontSize: '14px!important', color: '#242424' }
const treeConnector = {
  borderLeft: '1px solid #ccc',
  borderBottom: '1px solid #ccc',
  width: '12px',
  height: '14px',
  display: 'inline-block',
  mr: 1,
  ml: 1,
  mt: '-3px',
  alignSelf: 'flex-start',
  flexShrink: 0,
}

const InboundConfig = ({ orderItem }: { orderItem: OrderItemType }) => {
  const config: configType = orderItem.config
  type dayKey = keyof typeof config.business_days

  return <Grid container spacing={3}>
    <Grid item sm={6}>
      <Typography sx={labelStyle}>Inbound number</Typography>
      <Typography sx={valueStyle}>{config.inbound_number}</Typography>
      <Box sx={{ display: 'flex', mt: 0.5 }}>
        <Box sx={treeConnector} />
        <Box>
          <Typography sx={labelStyle}>Business hour routes</Typography>
          {config.routing_business_hours.map((row, key) => (
            <Box key={key} sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={treeConnector} />
              <Typography sx={valueStyle}>({key + 1}) {row.routing_number ?? row.routing_order_item_id} after {row.answered_after} seconds</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Grid>
    {config.routing_type === 'time_based' && config.business_days && <Grid item sm={6}>
      <Typography sx={labelStyle}>Business Hours</Typography>
      <Typography sx={valueStyle}>Day: {Object.keys(config.business_days).map(day => {
        const convertedKey = day as dayKey
        if (config.business_days && config.business_days[convertedKey] === 1) {
          return <Fragment key={day}>{day} </Fragment>
        }
        else {
          return <Fragment key={day}></Fragment>
        }
      })}</Typography>
      <Typography sx={valueStyle}>Time: {config.business_hour_from} to {config.business_hour_to}</Typography>
    </Grid>}
    {config.routing_type === 'time_based' && config.routing_after_hours && <Grid item sm={6}>
      <Typography sx={labelStyle}>After hour routes</Typography>
      {config.routing_after_hours.map((row, key) => (
        <Box key={key} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={treeConnector} />
          <Typography sx={valueStyle}>({key + 1}) {row.routing_number ?? row.routing_order_item_id} after {row.answered_after} seconds</Typography>
        </Box>
      ))}
    </Grid>}
  </Grid>
}

export default InboundConfig
